import React, { useState } from "react";
import { Button, Card, Form, Input, notification } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import authService from "services/authService";
import RouteEnum from "constants/RouteEnum";

const ForgotPassword = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const submit = async ({ email }) => {
    setLoading(true);
    try {
      const result = await authService.forgotPassword(email);
      sessionStorage.setItem("passwordResetChallenge", result.challenge_id);
      sessionStorage.setItem("passwordResetEmail", email);
      notification.success({ message: t("passwordResetEmailSent") });
      navigate(RouteEnum.VerifyPasswordReset);
    } catch {
      notification.error({ message: t("genericError") });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-layout d-flex align-items-center justify-content-center">
      <Card title={t("ForgotPassword")} style={{ width: 440, maxWidth: "94%" }}>
        <p>{t("forgotPasswordInstructions")}</p>
        <Form layout="vertical" onFinish={submit}>
          <Form.Item name="email" label={t("email")} rules={[{ required: true, type: "email" }]}>
            <Input autoComplete="email" />
          </Form.Item>
          <Button type="primary" htmlType="submit" block loading={loading}>
            {t("sendCode")}
          </Button>
        </Form>
        <Link to={RouteEnum.Login}>{t("backToLogin")}</Link>
      </Card>
    </div>
  );
};

export default ForgotPassword;
